import { IFieldError } from '../crud/form/error-response';
import { ValidatorMapper } from '../crud/form/validator-mapper';


export function flatValidationErrors(errors: IFieldError[]): string {
  if (!errors || errors.length === 0) {
    return '';
  }
  let msg = `<ul class="list-unstyled">`;
  errors.forEach((error: IFieldError) => {
    const e = error.constraints ? ValidatorMapper.map(error.constraints) : null;
    const m = error.error;
    if (e) {
      msg += Object.values(e).map(e => `<li>${e}</li>`).join('');
    }
    if (m) {
      const field = error.field ? error.field.charAt(0).toUpperCase() + error.field.slice(1) : null;
      msg += `<li>${field ? field + ': ' : ''}${m}</li>`;
    }
  });
  msg += '</ul>';
  return msg;
}
